import table from './VueTable.vue';
import dialog from './VueDialog.vue';
import pagination from './VuePagination.vue';

const globalComponents = {
  install: function (Vue) {
    Vue.component('VueTable', table);
    Vue.component('VueDialog', dialog);
    Vue.component('VuePagination', pagination);
  }
};

export default globalComponents;
